import type { Candidate } from "./poll"

export function byRanking(
  ranking: string[],
): (a: Candidate, b: Candidate) => number {
  return (a, b) => ranking.indexOf(a.id) - ranking.indexOf(b.id)
}
